import { __assign } from "tslib";
import LAYOUTS from '../../common/constants/layout';
import { calcTargetItemSize } from '../helpers/layoutHelper';
export var fixedStyles = {
    galleryLayout: LAYOUTS.EMPTY,
};
export var createStyles = function (styles) {
    return __assign(__assign(__assign({}, styles), fixedStyles), { targetItemSize: calcTargetItemSize(styles, Math.round(styles.gallerySize * 9 + 100)) });
};
//# sourceMappingURL=emptyGallery.js.map